// Fixed top-left BACK button for full-screen menus (owner 2026-11-02: 'in the settings menu, give me a back button, back arrow
// button at the top left of the screen that doesn't move, it's static, so I can get to it without having to scroll all the way down').
//
// HOW TO USE (any new full-screen menu, e.g. Achievements / How to play / Training):
//   1. give the screen a `.overlay` element with the title as its first <h2> child (index.html);
//   2. in main.ts boot code call   addBackButton($('#myscreen'), () => <the same thing Esc / gamepad B does>, () => sfx.pickup());
//   That is all: the shared CSS (`.backbtn`, `.overlay.has-back`) in src/style.css pins the button to the top-left of the
//   viewport (safe-area aware, 48 px+ touch target, themed for all five menu styles and all menu fonts) and keeps the title
//   clear of it. Never add per-screen back-button CSS. Keep the screen's bottom BACK row too (gamepad users).
//   The button is appended to <body> and shown only while the screen has `.show`.
//   Route onBack through the screen's own back handler (e.g. `menu.handle('back')`) so sub-states (reading a codex entry, the
//   save-import confirm) unwind exactly like Esc does.

const ARROW = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M15 5 8 12l7 7" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

export function addBackButton(screen: HTMLElement, onBack: () => void, click?: () => void): HTMLButtonElement {
  const old = document.querySelector<HTMLButtonElement>(`.backbtn[data-for="${screen.id}"]`);
  if (old) return old; // idempotent
  const b = document.createElement('button');
  b.type = 'button'; b.className = 'backbtn'; b.dataset.for = screen.id; b.innerHTML = ARROW;
  b.setAttribute('aria-label', 'Back'); b.title = 'Back';
  b.tabIndex = -1; // menus are driven by Esc / arrows / pad; a focused button would also fire on Enter / Space
  b.addEventListener('click', (e) => { e.stopPropagation(); click?.(); onBack(); b.blur(); });
  screen.classList.add('has-back');
  // The button lives on <body>, not inside the screen: an overlay is a scroll container with a backdrop-filter, and a
  // `position: fixed` child of such an element scrolls away with the content. It follows the screen's `show` class instead.
  const sync = () => { b.hidden = !screen.classList.contains('show'); };
  new MutationObserver(sync).observe(screen, { attributes: true, attributeFilter: ['class'] });
  sync();
  document.body.appendChild(b);
  return b;
}
